export default "__VITE_PUBLIC_ASSET__b367fcce__"